/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Admin resource route shells, two-panel item layout, and
 * activate/archive/delete chrome.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';

import {AppSharedModule} from '../app-shared.module';
import {ObjectStatesComponent} from '../directives/object-states.component';
import {ViewObjectStatesComponent} from '../directives/view-object-states.component';
import {ConfirmObjectStateModalComponent} from '../directives/confirm-object-state-modal.component';
import {TwoPanelLayoutComponent} from '../directives/two-panel-layout.component';
import {SignalAdminResourceContextActionsComponent} from './signal-admin-resource-context-actions.component';
import {SignalAdminResourceListComponent} from './signal-admin-resource-list.component';
import {SignalAdminResourceSpecifyIdModalComponent} from './signal-admin-resource-specify-id-modal.component';
import {SignalAdminResourceTitleComponent} from './signal-admin-resource-title.component';

const ADMIN_RESOURCE_PAGES = [
  TwoPanelLayoutComponent,
  SignalAdminResourceContextActionsComponent,
  SignalAdminResourceSpecifyIdModalComponent,
  SignalAdminResourceTitleComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ObjectStatesComponent,
    ViewObjectStatesComponent,
    ConfirmObjectStateModalComponent,
    SignalAdminResourceListComponent
  ],
  declarations: ADMIN_RESOURCE_PAGES,
  exports: [...ADMIN_RESOURCE_PAGES, SignalAdminResourceListComponent]
})
export class AdminResourcePagesModule {
}
